import {useEffect, useState} from 'react';

function throttle(func, limit) {
    let inThrottle;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
func.apply(context, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
        }
    };
}

export default function useEstMobile(breakPoint = 1380, delay = 500) {
    const [estMobile, setEstMobile] = useState(window.innerWidth < breakPoint);

    useEffect(() => {
        function handleResize() {
            setEstMobile(window.innerWidth < breakPoint);
        }

        window.addEventListener('resize', throttle(handleResize, delay));
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return estMobile;
}
